<div class="dialog-container">
    <div class="flex flex-col">
        @if (data.title) {
            <h3 class="mb-20 cutover-dialog-img-title" [innerHTML]="data.title | translate"></h3>
        }

        <div>
            @if (data.component) {
                <div>
                    <ng-container *ngComponentOutlet="data.component"></ng-container>
                </div>
            }
            @if (data.message) {
                <p [innerHTML]="data.message | translate"></p>
            }
        </div>

        @if (data.primaryButtonText || data.secondaryButtonText) {
            <div
                class="flex flex-col justify-end mt-30px w-auto sm:flex-row"
                [ngClass]="{ 'justify-between': data?.justifyBetween }"
            >
                @if (data.secondaryButtonText) {
                    <app-evida-button type="secondary" (clicked)="secondaryButtonClick()">
                        {{ data.secondaryButtonText | translate }}
                    </app-evida-button>
                }
                @if (data.primaryButtonText) {
                    <div class="mt-10px ml-0 sm:mt-0 sm:ml-10px"></div>
                }
                @if (data.primaryButtonText) {
                    <app-evida-button type="primary" (clicked)="primaryButtonClick()">
                        {{ data.primaryButtonText | translate }}
                    </app-evida-button>
                }
            </div>
        }
    </div>
</div>
